export default "__VITE_ASSET__D8t4lJ7b__"